<div class="main">
  <app-page-greeting />
</div>
